import { useSettings } from "../context/SettingsContext";

export const useIncomingCallSettings = () => {
  const { settings } = useSettings();

  return settings?.dateraServerAddress?.toString().length ? true : false;
};
